import get from 'lodash.get';
import { useState } from 'react';
import { heroValuePartner } from '../../../constants/partnerPageConst';
import { DefaultMeta } from '../../../types/partner-page-types';
import { If } from '../../Atoms/Conditionals';
import { Tooltip } from '../../Atoms/Tooltip';
import { addQueryParamToURL } from '../../Utils/CommonUtils';
import { IPartnerPlanData } from '../types';
import { getCheckoutUrl, getIsITRPlan } from '../utils/utils';
import { KeyFeatures } from './key-features';
import { OfferPricingCard } from './offer-pricing-card';
import { PlanFooter } from './plan-footer';
import { PlanIcon } from './plan-icon';
import { PriceCardCoupon } from './price-card-coupon';

interface IPriceCardProps {
  showPlanFooter: boolean;
  cardData: IPartnerPlanData;
  metaData: DefaultMeta;
  showKnowMore?: boolean;
  trackLabel?: string;
}
export const PriceCard = ({
  showKnowMore = true,
  showPlanFooter = false,
  cardData,
  metaData,
  trackLabel = '',
}: IPriceCardProps): JSX.Element => {
  const {
    name,
    listingId,
    pricing,
    offerPricing,
    whenRequired,
    planId,
    productServiceType,
  } = cardData.planDetails;
  const isItrPlan = getIsITRPlan(productServiceType);

  const couponCode = get(cardData, 'coupon.code', '');
  const [isCopied, setIsCopied] = useState(false);
  const { card_defaults } = metaData;
  const planName = get(card_defaults, `${planId}.name`, name) || name;
  const planLink = showPlanFooter
    ? addQueryParamToURL(
        isItrPlan ? heroValuePartner.btnLink : getCheckoutUrl(listingId),
        'coupon',
        cardData.coupon?.code
      )
    : heroValuePartner.btnLink;
  const getClasses = (showPlanFooterValue: boolean) => {
    if (!showKnowMore)
      return 'border rounded-lg relative mr-7 sm:ml-0 h-[545px] sm:h-[525px] sm:my-5';
    else if (showPlanFooterValue) {
      return 'border rounded-lg relative mr-7 sm:ml-0 h-[580px] sm:h-[575px] sm:mb-5';
    } else {
      return 'border rounded-lg relative mr-7 sm:ml-0 h-[490px] sm:h-[450px] sm:my-5';
    }
  };
  return (
    <div
      className={`${getClasses(
        showPlanFooter
      )} bg-white sm:w-[94%] price-card-wrapper transform transition-transform duration-300 ease-in-out hover:scale-110 sm:hover:scale-100`}
    >
      <div className="p-6 sm:px-5">
        <a href={planLink}>
          <div className="flex h-12">
            <p className="text-font-500 font-semibold text-s-20 w-2/3 customEllipses leading-6">
              {planName as string}
            </p>
          </div>
          <div className="mt-7">
            <OfferPricingCard
              pricing={pricing}
              originalPrice={offerPricing.originalPrice}
              productServiceType={productServiceType}
              coupon={cardData.coupon}
            />
          </div>
        </a>
        <div className="h-24 sm:h-20 mt-6">
          {couponCode && cardData.coupon ? (
            <Tooltip
              content={
                <div className="bg-[#041832] px-2 mt-1 rounded-sm flex justify-center text-white text-s-12 text-center">
                  {isCopied
                    ? `Copied ${couponCode}`
                    : 'Click to copy and apply it during checkout'}
                </div>
              }
              hideCloseIcon={true}
              showOnHover={true}
              icon=""
              direction="bottom"
              contentPosition={'absolute'}
            >
              <PriceCardCoupon
                coupon={cardData.coupon}
                setIsCopiedCB={setIsCopied}
              />
            </Tooltip>
          ) : (
            ''
          )}
        </div>

        <a className="mt-7" href={planLink}>
          <p className="font-medium text-s-14 mb-3 mt-8">Key Features</p>
          <KeyFeatures services={whenRequired} textClasses="font-semibold" />
        </a>
        <If condition={showPlanFooter}>
          <PlanFooter
            listingId={listingId}
            planId={planId}
            coupon={cardData.coupon?.code}
            productServiceType={productServiceType}
            showKnowMore={showKnowMore}
            trackLabel={trackLabel}
          />
        </If>
      </div>
      <PlanIcon planId={planId} card_defaults={card_defaults} />
    </div>
  );
};
